import lenochod from "../assets/illustrations/lenochod.jpg";
import lvicek from "../assets/illustrations/lvicek.jpg";
import meduza from "../assets/illustrations/meduza.jpg";
import spiciDrak from "../assets/illustrations/spici-drak.jpg";
import velryby from "../assets/illustrations/velryby.jpg";
import zajicBalon from "../assets/illustrations/zajic-balon.jpg";
import zajicRakos from "../assets/illustrations/zajic-rakos.jpg";
import zelva from "../assets/illustrations/zelva.jpg";
import hrosikGreen from "../assets/illustrations/hrosik-green.jpg";
import hrosikRed from "../assets/illustrations/hrosik-red.jpg";
import kockaDyne from "../assets/illustrations/kocka-dyne.jpg";
import meduzkaBlue from "../assets/illustrations/meduzka-blue.jpg";
import medvedKruh from "../assets/illustrations/medved-kruh.jpg";
import ovecka from "../assets/illustrations/ovecka.jpg";
import plamenak from "../assets/illustrations/plamenak.jpg";
import psychoZaba from "../assets/illustrations/psycho-zaba.jpg";
import slunecnice from "../assets/illustrations/slunecnice.jpg";
import velrybyWhite from "../assets/illustrations/velryby-white.jpg";
import vilaGreen from "../assets/illustrations/vila-green.jpg";
import vilaParez from "../assets/illustrations/vila-parez.jpg";
import vilaRed from "../assets/illustrations/vila-red.jpg";
import zirafkaGreen from "../assets/illustrations/zirafka-green.jpg";
import zirafkaPink from "../assets/illustrations/zirafka-pink.jpg";
import pandaCervena from "../assets/illustrations/panda-cervena.jpg";
import duch from "../assets/illustrations/duch.jpg";
import a01 from "../assets/illustrations/01.jpeg";
import b1 from "../assets/illustrations/b1.jpeg";
import b2 from "../assets/illustrations/b2.jpeg";
import b3 from "../assets/illustrations/b3.jpeg";
import b4 from "../assets/illustrations/b4.jpeg";
import b5 from "../assets/illustrations/b5.jpeg";
import b6 from "../assets/illustrations/b6.jpeg";
import b7 from "../assets/illustrations/b7.jpeg";

export const ILLUSTRATIONS = {
  lenochod,
  lvicek,
  meduza,
  spiciDrak,
  velryby,
  zajicBalon,
  zajicRakos,
  zelva,
  hrosikGreen,
  hrosikRed,
  kockaDyne,
  meduzkaBlue,
  medvedKruh,
  ovecka,
  plamenak,
  psychoZaba,
  slunecnice,
  velrybyWhite,
  vilaGreen,
  vilaParez,
  vilaRed,
  zirafkaGreen,
  zirafkaPink,
  pandaCervena,
  duch,
  a01,
  b1,
  b2,
  b3,
  b4,
  b5,
  b6,
  b7,
};

export const DIGITAL_PAINTINGS = {};

export const modalExpandedWidth = "450px";
